const POSITIVE_NUMBERS_REGEX = /^((\d+)(\.\d*)?)?$/;

export { POSITIVE_NUMBERS_REGEX };
